import * as React from 'react'
import {formatDate, translateCountryName} from "@ui-seeker/utils"

import { RetailerBlock } from "@components"


export default function retailerColumn() {
    return [{
        name: 'date', label: 'Date',
        options: {
            display: 'excluded',
            customBodyRowRender: value => formatDate(value, { isString: true })
        }
    }, {
        name: 'country', label: 'Site Country',
        options: {
            display: 'excluded',
            customBodyRowRender: v => translateCountryName(v)
        }
    },{
        name: 'retailer', label: 'Retailer',
        options: {
            headerAlign: 'left',
            customBodyRowRenderLite: (value, { country, date, siteURL }) => <RetailerBlock
                retailer={value}
                country={country}
                date={date}
                siteURL={siteURL}
            />
        }
    }]
}